// Small client-side plan helpers mirroring api/src/modules/game-plan/engine
// (plan-engine.ts). Used for snapping the view to a logged activity's week and
// labelling the viewed week's phase without a round-trip.

const DAY = 86400000;
const PLAN_LENGTH_DAYS = 112;

function utcMidnightISO(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number);
  return Date.UTC(y, (m || 1) - 1, d || 1);
}

// Plan week (1..16) a yyyy-mm-dd date falls in, clamped to the window.
export function planWeekOfDate(grandOpeningISO: string, dateISO: string): number {
  const start = utcMidnightISO(grandOpeningISO) - PLAN_LENGTH_DAYS * DAY;
  const dayIdx = Math.floor((utcMidnightISO(dateISO) - start) / DAY);
  if (dayIdx < 0) return 1;
  return Math.min(16, Math.floor(dayIdx / 7) + 1);
}

// 0-based phase index (foundation…countdown) for a plan week.
export function phaseIndexForWeek(w: number): number {
  return w <= 2 ? 0 : w <= 4 ? 1 : w <= 8 ? 2 : w <= 12 ? 3 : 4;
}
